import { render, staticRenderFns } from "./ProjectSettingsGeneral.vue?vue&type=template&id=cf97dc66&scoped=true&"
import script from "./ProjectSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSettingsGeneral.vue?vue&type=style&index=0&id=cf97dc66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf97dc66",
  null
  
)

export default component.exports